if (!window.soulSunFeaturedVideoReady) {
  window.soulSunFeaturedVideoReady = true;

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-featured-video-play]');
    if (!button) return;

    var iframe = document.createElement('iframe');
    iframe.src = button.dataset.videoUrl;
    iframe.title = button.dataset.videoTitle;
    iframe.width = '850';
    iframe.height = '480';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    button.replaceWith(iframe);
    iframe.focus();
  });
}
